export const TAPBAR_MOBILE_ID = 'tapbar-mobile';
